/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Templates_Drag_CancelInputs */



/**
* | output |
* | --- |
* | "Move of {name} cancelled." |
*
* @param {Settings_Templates_Drag_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_drag_cancel = /** @type {((inputs: Settings_Templates_Drag_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Drag_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verplaatsen van ${i?.name} geannuleerd.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacement de ${i?.name} annulé.`)
	return /** @type {LocalizedString} */ (`Move of ${i?.name} cancelled.`)
});